import React from 'react';
import { string } from 'prop-types';
import parse from 'html-react-parser';

export default function TextBlock({ text }) {
    return (
        <div className="c-text-block">
            <div className="text-container">
                {parse(text)}
            </div>
        </div>
    );
}

TextBlock.propTypes = { text: string };

TextBlock.defaultProps = { text: '' };
